import React, { Component } from "react";

//IMPORT REDUX
import { connect } from "react-redux";
import { addModalExport } from "../../actions/ConfigFileAction";
import { addReset } from "../../actions/AppActions";
import Exit from "../../assets/img/Exit.svg";

//IMPORT SEMANTIC COMPONENTS
import "semantic-ui-css/semantic.min.css";
import {
  Grid,
  Segment,
  Button,
  Icon,
  Modal,
  Header,
  Image,
  Form,
  Label,
  Item,
  Container
} from "semantic-ui-react";

import "./ResetPassword.css";

import API from "../../services/Api";

import { translate } from "react-translate";

const mapStateToProps = state => ({
  app: state.app,
  configfile: state.configfile
});

const mapActionToProps = {
  addModalExport: addModalExport,
  addReset: addReset
};

class ConnectedResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      error_input_email: null,
      response: null
    };

    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModalExport = this.closeModalExport.bind(this);
  }

  closeModalExport() {
    this.props.addReset(false);
  }

  handleChangeEmail(e) {
    if (
      e.target.value === "" ||
      e.target.value === null ||
      e.target.value === undefined
    ) {
      this.setState({
        email: e.target.value,
        error_input_email: true
      });
    } else {
      this.setState({
        email: e.target.value,
        error_input_email: false
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    var self = this;
    if (
      this.state.email === "" ||
      this.state.email === null ||
      this.state.email === undefined
    ) {
      this.setState({
        email: e.target.value,
        error_input_email: true
      });
    } else {
      if (!this.state.error_input_email) {
        var resetData = {
          email: this.state.email
          // lang: this.props.app.lang
        };
        API.ResetPassword(resetData).then(res => {
          self.setState({
            response: res.data
          });
        });
      } else {
        this.setState({
          email: e.target.value,
          error_input_email: true
        });
      }
    }

    return false
  }

  // sendResetPassword() {
  //     var form = new FormData()
  //     form.append('email', this.state.email)
  //     API.ResetPassword(form)
  //     this.setState({
  //         loading:false
  //     })
  // }

  render() {
    const { t } = this.props;
    return (
      <Modal
        observeChanges="true"
        size="mini"
        open={this.props.app.reset}
        id="resetPasswordMain"
      >
        <Modal.Content id="windowPassword">
          <Grid
            // textAlign='center'
            // style={{ height: '100%' }}
            verticalAlign="middle"
          >
            <Grid.Column>
              <Image
                onClick={this.closeModalExport}
                src={Exit}
                centered
                floated="right"
                id="exit"
              />
              <Header as="h3" className="headerPassword">
                {t("reset_password_title")}
              </Header>

              <Form onSubmit={this.handleSubmit}>
                <Item.Header as="h5">{t("reset_password_label")}</Item.Header>

                {this.state.error_input_email ? (
                  <input
                    type="email"
                    onChange={this.handleChangeEmail}
                    style={{
                      marginBottom: "17px",
                      backgroundColor: "#f7f7f9",
                      color: "#707070",
                      borderColor: "#db2828"
                    }}
                    className="labelstyling"
                  />
                ) : (
                  <input
                    type="email"
                    onChange={this.handleChangeEmail}
                    style={{
                      marginBottom: "17px",
                      backgroundColor: "#f7f7f9",
                      color: "#707070"
                    }}
                    className="labelstyling"
                  />
                )}

                {this.state.response ? (
                  <Grid.Column
                    verticalAlign={"middle"}
                    style={{ paddingBottom: "15px" }}
                  >
                    <Segment inverted color="green" tertiary>
                      <Icon name={"checkmark"} />
                      {t("success")}
                    </Segment>
                  </Grid.Column>
                ) : (
                  <div />
                )}
                <Button type="submit" fluid id="buttonSend">
                  {t("reset_password_button")}
                </Button>
              </Form>
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}

const ResetPassword = connect(
  mapStateToProps,
  mapActionToProps
)(ConnectedResetPassword);
export default translate("ResetPassword")(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/Login/ResetPassword.jsx